import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { tankConstant } from "../constants/constants";


class TankStore extends EventEmitter {
    constructor() {
        super();
        this.tanks = [];
        this.dipTable = [];
    }

    getAll() {
        return this.tanks;
    }
    getAllDip() {
        return this.dipTable;
    }
    handleAction(action) {
        switch (action.type) {
            case tankConstant.TANK_CREATED: {
                this.tanks.push(action.tank);
                this.emit(tankConstant.TANK_CREATED, action.msg);
                this.emit(tankConstant.TANK_STORE_CHANGE);
                break;
            }
            case tankConstant.TANK_CREATION_FAILED: {
                this.emit(tankConstant.TANK_CREATION_FAILED, action.msg);
                break;
            }
            case tankConstant.FETCHED_ALL_TANKS: {
                //console.log("inside tank store ", action.data);
                this.tanks = action.data;
                this.emit(tankConstant.TANK_STORE_CHANGE);
                break;
            }
            case tankConstant.TANK_FETCH_FAILED: {
                this.emit(tankConstant.TANK_FETCH_FAILED, action.msg);
                break;
            }
            case tankConstant.FETCHED_ALL_DIP_TABLE: {

                this.dipTable = action.data;
                this.emit(tankConstant.FETCHED_ALL_DIP_TABLE, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const tankStore = new TankStore();
dispatcher.register(tankStore.handleAction.bind(tankStore));
export default tankStore;


// WEBPACK FOOTER //
// ./src/jsx/store/tank-store.jsx